import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { EnvColorService } from "../env-color/env-color.service";

@Component({
  selector: "ab-env-label",
  templateUrl: "./env-label.component.html",
})
export class EnvLabelComponent implements OnChanges, OnInit {
  @Input() public env: string;
  @Input() public truncate: boolean;
  public truncateAt: number;
  public class: string;

  constructor(private envColorService: EnvColorService) {}

  public ngOnInit() {
    this.render();
  }
  public ngOnChanges() {
    this.render();
  }

  private render() {
    this.class = this.envColorService.colorClass(this.env);
    this.truncateAt = this.truncate ? 2 : 20;
  }
}
